import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  levelId: PropTypes.number
};

export const defaultProps = {
  id: null,
  title: null,
  levelId: null
};

export default { defaultProps, propTypes };
